import cn from "classnames";
import type React from "react";
import { useSelector } from "react-redux";
import type { PersistPartial } from "redux-persist/es/persistReducer";
import { Loader } from "rsuite";
import type { RootState } from "../../../../app/store/store";
import { useGetUserByIdQuery } from "../../../../entities/User/userApi";
import style from "./ShowCompletedIcon.module.scss";

interface Props {
	id: string;
}

export const ShowCompletedIcon: React.FC<Props> = ({ id }) => {
	const authStore = useSelector(
		(
			state: RootState &
				PersistPartial & {
					auth: {
						isAuthenticated: boolean;
						user: {
							userId: string;
						};
					};
				},
		) => state?.auth,
	);
	const {
		data: userData,
		isLoading,
		error,
	} = useGetUserByIdQuery(authStore.user.userId, {
		skip: !authStore.isAuthenticated,
	});

	if (isLoading) {
		return <Loader center content="loading" vertical />;
	}

	if (error) {
		return <div>Error</div>;
	}

	if (!userData) {
		return;
	}

	const isCompleted = userData?.completedActivities?.some(
		(activity) => activity.activity._id === id,
	);

	return (
		<div
			className={cn(style.container, {
				[style.completed]: isCompleted,
			})}
		>
			<div
				className={cn(style.check, {
					[style.completed]: isCompleted,
				})}
			>
				{isCompleted ? "✓" : ""}
			</div>
			completed
		</div>
	);
};
